// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + "6bb1c8f0" + ".chunk.js";
};